/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import React, { useCallback, useContext, useState } from 'react'
import { useServiceContext } from '../../../root'
import { RcmTableDataWrapper } from '../../../components/rcm-table/RcmTableDataWrapper'
import RcmTableFilterTrigger from '../../../components/rcm-table/RcmTableFilterTrigger'
import PageMenu from './PageMenu'
import TableFilter from './TableFilter'
import Table from './Table'
import { Tag, tagsApiService } from '../../../services/api/api.tags'
import ModalEdit from './Actions/ModalEdit'
import { RcmTableDataContext } from '../../../components/rcm-table/RcmTableDataContext'

const TagsContent: React.FC = () => {
  const tableContext = useContext(RcmTableDataContext)
  const context = useServiceContext()
  const { translate } = context.service.filter
  const [editingTag, setEditingTag] = useState<Tag | null>(null)
  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleOpenModal = (tag?: Tag) => {
    setEditingTag(tag || null)
    setIsModalOpen(true)
  }

  const handleCloseModal = () => {
    setIsModalOpen(false)
    setEditingTag(null)
  }

  return (
    <>
      <div>
        <div className="row">
          <div className="col-xs-12">
            <div className="d-flex flex-wrap" style={{ paddingBottom: '1%' }}>
              <h1 className="align-left align-top" id="2d10e850-9984-4d15-ad97-dc27960ff86e" style={{ margin: '0' }}>
                {translate('TAGS_TITLE')}
              </h1>

              <div className="align-right align-bottom d-flex">
                <PageMenu onAddTag={() => handleOpenModal()} />
                <RcmTableFilterTrigger />
              </div>
            </div>

            <TableFilter />
            <Table onEditTag={handleOpenModal} onDeleteSuccess={() => tableContext?.refreshTable()} />
          </div>
        </div>
      </div>
      {isModalOpen && <ModalEdit tag={editingTag || undefined} onClose={handleCloseModal} />}
    </>
  )
}

const TagsPage: React.FC = () => {
  // Create loadData function for RcmTableDataWrapper
  const loadData = useCallback(async (pagingParams: any, filter: any) => {
    try {
      // Extract IDs from filter.types array - each item has structure { value: id, label: name }
      const typeIds = filter?.types && filter.types.length > 0 ? filter.types.map((t: any) => t.value || t.id || t) : []

      const params = {
        pageStart: pagingParams.pageStart || 0,
        pageSize: pagingParams.pageSize || 15,
        sortBy: pagingParams.sortBy || 'NAME',
        sortDesc: pagingParams.sortDesc !== undefined ? pagingParams.sortDesc : false,
        ...(typeIds.length > 0 ? { id: typeIds } : {}),
        ...(filter?.type ? { type: filter.type } : {})
      }

      const result: any = await tagsApiService.getListForTable(params)

      return {
        elements: result.elements || [],
        totalElements: result.totalElements || 0
      }
    } catch (error) {
      console.error('Error loading tags:', error)
      return {
        elements: [],
        totalElements: 0
      }
    }
  }, [])

  return (
    <div className="mcc-content-frame theme-sandman">
      <RcmTableDataWrapper
        loadData={loadData}
        defaultSortBy="NAME"
        defaultSortDesc={false}
        persistenceKey="settingsTags"
        doPreload={true}
      >
        <TagsContent />
      </RcmTableDataWrapper>
    </div>
  )
}

export default TagsPage
